import { FormLabel } from '@/components/ui/form'
import { useContext, useMemo } from 'react'
import { FormContext } from '../FormProvider'
import { FormFieldProps, FormCheckboxGroupType } from './type'
import { Checkbox } from '@/components/ui/checkbox'
import { Row } from '@/@diffrag/components/base'

export const FormCheckboxGroupField = ({
  data,
  field,
}: FormFieldProps<FormCheckboxGroupType>) => {
  const context = useContext(FormContext)

  const selectedInternal = useMemo(() => {
    return (
      field.value
        ?.map((item: any) => {
          if (typeof item === 'string') {
            const option = data.options.find((option) => option.id === item)

            if (option) {
              return option
            }
          }

          if (typeof item === 'object') {
            const option = data.options.find((option) => option.id === item.id)

            if (option) {
              return option
            }
          }

          return null
        })
        .filter(Boolean) ?? []
    )
  }, [field.value, data.options])

  return (
    <div className="flex flex-row gap-4 py-1">
      {data.options.map((option) => {
        const isSelected = selectedInternal.some(
          (item: any) => item.id === option.id,
        )

        return (
          <Row key={option.id} className="items-center gap-2">
            <Checkbox
              id={`${String(data.key)}-${option.id}`}
              checked={isSelected}
              disabled={data.readOnly}
              onCheckedChange={(checked) => {
                return checked
                  ? field.onChange([...selectedInternal, option])
                  : field.onChange(
                      selectedInternal.filter(
                        (value: any) => value.id !== option.id,
                      ),
                    )
              }}
            />
            <FormLabel
              htmlFor={`${String(data.key)}-${option.id}`}
              className="text-[13px] font-normal text-gray-700"
            >
              {option.label || option.id}
            </FormLabel>
          </Row>
        )
      })}
    </div>
  )
}
